const ADMIN_ATTENTION_TYPES = new Set([
  "membership_expiring",
  "medical_expiring",
  "medical_expired",
  "debt",
  "debtors",
  "unpaid_membership",
  "pending_registration",
  "competition_application",
  "poll_pending",
  "subscription_expiring",
  "session_unfinished",
]);

/** Старые ссылки на календарь для незакрытой переклички → журнал с занятием */
export function resolveAdminNotificationHref(item) {
  const raw = item?.url || item?.action_path || item?.href;
  if (!raw) return null;
  if (item?.type !== "session_unfinished" || !raw.includes("/schedule")) {
    return raw;
  }
  try {
    const url = new URL(raw, "https://local");
    const session =
      url.searchParams.get("session") || url.searchParams.get("sessionId");
    const date = url.searchParams.get("date");
    const group =
      url.searchParams.get("group") || url.searchParams.get("groupId");
    const base = raw.startsWith("/staff/") ? "/staff/app" : "/manage/app";
    const params = new URLSearchParams();
    if (date) params.set("date", date);
    if (session) params.set("session", session);
    if (group) params.set("group", group);
    const qs = params.toString();
    return qs ? `${base}/journal?${qs}` : `${base}/journal`;
  } catch {
    return raw;
  }
}

export function formatNotificationText(item) {
  if (!item) return "";
  if (item.type === "chat_message") {
    const url = String(item.url || "");
    if (url.includes("/app/chat/personal")) {
      return "У вас новое сообщение";
    }
    if (url.includes("/app/chat/group/")) {
      return "Новое сообщение в чате группы";
    }
    if (url.includes("/app/chat")) {
      return "У вас новое сообщение";
    }
    const rawTitle = String(item.title || "").trim();
    const name = rawTitle
      .replace(/^Сообщение:\s*/i, "")
      .replace(/^Чат$/i, "")
      .trim();
    if (name && name !== "Сообщение от клиента" && name !== "Сообщение от клуба") {
      return `Новое сообщение от ${name}`;
    }
    return "Новое сообщение от клиента";
  }

  const text = String(item.text || item.body || "").trim();
  if (text.length <= 96) return text;
  return `${text.slice(0, 93)}…`;
}

export function formatNotificationLabel(item) {
  if (!item) return "Уведомление";
  if (item.type === "chat_message") return "Чат";
  return item.title || item.action_label || "Уведомление";
}

export function filterDashboardNotifications(notifications) {
  return (notifications || []).filter((n) => {
    if (n.type === "revenue" || n.type === "absent_long") return false;
    if (ADMIN_ATTENTION_TYPES.has(n.type)) return true;
    if (n.type === "membership_expiring" || n.type === "medical_expiring") {
      return n.tone === "warn" || n.tone === "danger";
    }
    return false;
  });
}

export function mergeAdminNotificationFeed(pushFeed, dashboardFeed) {
  const map = new Map();
  for (const item of [...pushFeed, ...dashboardFeed]) {
    const key = item.id || `${item.type}:${item.text}`;
    if (!map.has(key)) map.set(key, item);
  }
  return [...map.values()].sort((a, b) => {
    const ta = new Date(a.sent_at || 0).getTime();
    const tb = new Date(b.sent_at || 0).getTime();
    return tb - ta;
  });
}

export function normalizeAdminNotification(item) {
  const href = resolveAdminNotificationHref(item);
  return {
    ...item,
    title: formatNotificationLabel(item),
    text: formatNotificationText(item),
    url: href,
    action_path: href || item.action_path,
    is_read: Boolean(item.is_read ?? item.read_at),
  };
}

/** Опрос из training-polls → элемент ленты уведомлений */
export function formatPollNotificationItem(row) {
  const poll = row.poll || {};
  const question =
    row.question || poll.questions?.[0]?.text || poll.title || row.title || "Требуется ответ";
  return {
    id: `poll-${row.id || row.dispatch_id || poll.id}`,
    type: "poll",
    entity_key: String(row.id || row.dispatch_id || poll.id),
    title: poll.title || row.title || "Опрос",
    text: question,
    url: "/app/notifications",
    tone: "info",
    actionable: true,
    sent_at: row.sent_at || row.createdAt || new Date().toISOString(),
    is_read: false,
    poll_row: row,
  };
}

export function mergeClientNotificationItems(logItems = [], pollRows = []) {
  const map = new Map();
  for (const item of [...logItems, ...pollRows]) {
    const key = item.id || `${item.type}:${item.entity_key || item.text}`;
    if (!map.has(key)) map.set(key, item);
  }
  return [...map.values()].sort((a, b) => {
    const ta = new Date(a.sent_at || 0).getTime();
    const tb = new Date(b.sent_at || 0).getTime();
    return tb - ta;
  });
}
